import "./Projects.scss";
import React, { useEffect, useState } from "react";
import AnimateLetters from "../../components/AnimateLetters";
import FlipCard from "../../components/FlipCard";
import BLINDASSISTANCEOBJECTDETECTIONANDNAVIGATION from "../../assets/images/blind.png.png";
import Buzzcars from "../../assets/images/how-to-create-a-car-NewBlogCover.png";
import SONG from "../../assets/images/Song.png";
import NM from "../../assets/images/nm.jpeg";
import food from "../../assets/images/food.jpg";
import Mines from "../../assets/images/ma.png";
import AI from "../../assets/images/ai.png";
function Projects() {
  const [letterClass, setLetterClass] = useState("animate-text");
  const projectsArray = ["P", "r", "o", "j", "e", "c", "t", "s"];

  useEffect(() => {
    setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);

  return (
    <>
      <div className="container projects-page">
        <div className="text-zone">
          <h1>
            <AnimateLetters
              letterClass={letterClass}
              strArray={projectsArray}
              idx={15}
            />
          </h1>
        </div>
        <div className="project-cards">
          <p>
            Hello! Thank you for making it this far in my website! These are
            some of my work.
          </p>

          <FlipCard
            projectName={"Zosh Food: Revolutionizing Online Food Delivery	"}
            title={"Zosh Food: Revolutionizing Online Food Delivery	"}
            description={
              "Zosh Food is a state-of-the-art Online Food Delivery Application that bridges the gap between restaurants and food enthusiasts. "
            }
            //projectLink={'https://animebutler.herokuapp.com'}
            githubLink={""}
            img={food}
          />
          <FlipCard
            projectName={"TuneHub"}
            title={"TuneHub"}
            description={
              "This application is built using SpringBoot, React.js, SASS is meant for users (Admin and Customers) who can access and play songs from the app "
            }
            githubLink={
              "https://github.com/rahulmg23/DBMS-/tree/master/DBMS-Project-master"
            }
            img={SONG}
          />
          <FlipCard
            projectName={"Minesweeper"}
            title={"Minesweeper"}
            description={
              'A revamped version of the classic logic-based, single-player computer game. The object of the game is to find the randomly placed mines by clicking on "safe" squares. Player can either flag the squares with mines or avoid them entirely.'
            }
            projectLink={"https://minsweeper.vercel.app/"}
            githubLink={"https://github.com/rahulmg23/Minsweeper"}
            img={Mines}
          />

          <FlipCard
            projectName={"Gemini"}
            title={"Gemini"}
            description={
              "Google Gemini AI is designed to understand different information modes, such as text, images, audio, video, computer code, and more. In addition, its excellent at several coding tasks, such as translating Code between languages."
            }
            projectLink={"https://gemini-ai-delta.vercel.app/"}
            githubLink={"https://github.com/rahulmg23/GeminiAI"}
            img={AI}
          />
          <FlipCard
            projectName={"BLIND-ASSISTANCE-OBJECT-DETECTION-AND-NAVIGATION"}
            title={"BLIND-ASSISTANCE-OBJECT-DETECTION-AND-NAVIGATION"}
            description={
              "This is a vision enhancer based module specifically for the BLIND VICTIMS. The system is designed in such a way in which the blind person can take the help of AN APPLICATION"
            }
            githubLink={
              "https://github.com/rahulmg23/rahulmg23-BLIND-ASSISTANCE-OBJECT-DETECTION-AND-NAVIGATION"
            }
            img={BLINDASSISTANCEOBJECTDETECTIONANDNAVIGATION}
          />
          <FlipCard
            projectName={"Car Dealearship Managment"}
            title={"Car Dealearship Managment"}
            description={
              "This application is meant for users (Employees and Customers) who can access the information from database about car deals"
            }
            githubLink={
              "https://github.com/rahulmg23/DBMS-/tree/master/DBMS-Project-master"
            }
            img={Buzzcars}
          />
          <FlipCard
            projectName={"TuneHub"}
            title={"TuneHub"}
            description={
              "This application is built using SpringBoot, React.js, SASS is meant for users (Admin and Customers) who can access and play songs from the app "
            }
            githubLink={
              "https://github.com/rahulmg23/DBMS-/tree/master/DBMS-Project-master"
            }
            img={SONG}
          />
          <FlipCard
            projectName={"Appointment Management System using AI IOT"}
            title={"Appointment Management System using AI IOT"}
            description={
              "This application is built using PHP,C++,SQL is meant for users (Admin and Customers) to book appointment using IOT device"
            }
            githubLink={
              "https://github.com/rahulmg23/DBMS-/tree/master/DBMS-Project-master"
            }
            img={NM}
          />
        </div>
      </div>
    </>
  );
}

export default Projects;
